var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreedotsOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59759 10.2273C7.64599 11.2757 7.63618 12.9853 6.58778 14.0337C5.53939 15.082 3.8298 15.0919 2.78141 14.0435C1.73301 12.9951 1.74282 11.2855 2.79122 10.2371C3.83961 9.1887 5.5492 9.17889 6.59759 10.2273Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0435 2.78141C15.0919 3.8298 15.082 5.53939 14.0337 6.58778C12.9853 7.63618 11.2757 7.64598 10.2273 6.59759C9.17889 5.5492 9.1887 3.83961 10.2371 2.79122C11.2855 1.74282 12.9951 1.73301 14.0435 2.78141Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7727 17.4024C14.8211 18.4508 14.8113 20.1604 13.7629 21.2088C12.7145 22.2572 11.0049 22.267 9.95653 21.2186C8.90814 20.1702 8.91795 18.4606 9.96634 17.4122C11.0147 16.3638 12.7243 16.354 13.7727 17.4024Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2186 9.95653C22.267 11.0049 22.2572 12.7145 21.2088 13.7629C20.1604 14.8113 18.4508 14.8211 17.4024 13.7727C16.354 12.7243 16.3638 11.0147 17.4122 9.96634C18.4606 8.91795 20.1702 8.90814 21.2186 9.95653Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreedotsOff);
export default __webpack_public_path__ + "static/media/treedots_off.bec8c91e3b4d80baf2bc16142aae664f.svg";
export { ForwardRef as ReactComponent };